import { useMutation, useQueryClient } from "@tanstack/react-query";
import { AxiosError } from "axios";
import { ErrorResponse } from "react-router-dom";
import { updateBusinessPolicies } from "hooks/api/business-settings";
import { UpdateBusinessPoliciesForm } from "shared/types";
import { getApiSuccessMessage, getApiErrorMessage } from "shared/utils";
import { translate } from "shared/languages";

export const useUpdateBusinessPolicies = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (form: UpdateBusinessPoliciesForm) =>
      updateBusinessPolicies(form),
    onSuccess: () => {
      getApiSuccessMessage(translate("class_settings.toast.saved"));
      // Settings drive waitlist caps, cancellation snapshots and the client
      // visibility window, so refresh everything that reads them.
      queryClient.invalidateQueries({ queryKey: ["business"] });
      queryClient.invalidateQueries({ queryKey: ["schedule-v2"] });
      queryClient.invalidateQueries({ queryKey: ["waitlist-v2"] });
      queryClient.invalidateQueries({ queryKey: ["booking-v2"] });
      // Switching the waitlist off returns the held credits of every spot.
      queryClient.invalidateQueries({ queryKey: ["customer_package"] });
    },
    onError: (error: AxiosError<ErrorResponse>) => getApiErrorMessage(error),
  });
};
